import React from "react";

const AffiliateDashboardShimmer = ({ size = 6 }) => {
    return (
        <div className="affiliate-list-wrap affiliate-shimmer">
            <ul>
                {new Array(size).fill({}).map((a, index) => (
                    <li>
                        <div className="shimmer affiliate-card-shimmer">
                            <div className="wrappercard">
                                <div className="image-card animate"></div>
                                <div className="shimmercontant">
                                    <div className="stroke animate title1"></div>
                                    <div className="stroke animate title2"></div>
                                    <div className="stroke animate title3"></div>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default AffiliateDashboardShimmer;